import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "admin-main-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "content-header" }, [
  /*#__PURE__*/_createVNode("h2", null, " 발주 내역 ")
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "inner" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "ion ion-bag" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 바로가기 ")
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.placingOrderInfo, (placingOrder) => {
        return (_openBlock(), _createBlock("div", {
          class: "col-lg-3 col-6",
          key: placingOrder.data_cd
        }, [
          (placingOrder.seller_data_cd)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: ["small-box bg-success", { 'bg-danger': placingOrder.count === '0' }]
              }, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("h3", null, _toDisplayString(placingOrder.seller_name), 1),
                  _createVNode("p", null, "발주완료 건수 " + _toDisplayString(placingOrder.count) + "건", 1)
                ]),
                _hoisted_5,
                _createVNode(_component_router_link, {
                  to: 
              `/commerce/placing-order-after/list/${placingOrder.seller_data_cd}`
            ,
                  class: "small-box-footer"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["to"])
              ], 2))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}